export default {"src":"/_next/static/media/protein-powder.e749f703.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};